module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-3.c6321246.svg";